// src/types/seo/serializeHeadTags.ts
var HEAD_TAG_MARKER = "data-maat-head";
var escapeHtml = (value) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
var serializeJsonLd = (json) => JSON.stringify(json).replace(/</g, "\\u003c").replace(/>/g, "\\u003e").replace(/&/g, "\\u0026").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
var serializeTag = (tag) => {
  switch (tag.kind) {
    case "title":
      return `<title>${escapeHtml(tag.text)}</title>`;
    case "meta":
      return `<meta ${tag.attr}="${escapeHtml(tag.key)}" content="${escapeHtml(tag.content)}" ${HEAD_TAG_MARKER}>`;
    case "link":
      return `<link rel="${tag.rel}" href="${escapeHtml(tag.href)}" ${HEAD_TAG_MARKER}>`;
    case "jsonld":
      return `<script type="application/ld+json" ${HEAD_TAG_MARKER}>${serializeJsonLd(tag.json)}</script>`;
  }
};
var serializeHeadTags = (tags) => tags.map(serializeTag).join("\n");

export {
  HEAD_TAG_MARKER,
  serializeJsonLd,
  serializeHeadTags
};
